import { CSSProperties } from 'react'

const TaskIcon = ({ color = '#151515', style }: { color?: string; style?: CSSProperties }) => {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={style}
        >
            <g id="GiGi-Assistant" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="2.5.-My-Approvals---Main" transform="translate(-186.000000, -770.000000)" fill={color} fillRule="nonzero">
                    <g id="Group-10" transform="translate(0.000000, 760.000000)">
                        <g id="Bars/Tab-Bars/Compact/Light/3-Item-Tab-Bar" transform="translate(0.000000, 1.000000)">
                            <g id="task" transform="translate(186.000000, 4.000000)">
                                <g id="task_alt" transform="translate(0.000000, 5.000000)">
                                    <path
                                        d="M20,3.18 L8.59,14.6 L4.35,10.36 L5.76,8.95 L8.59,11.78 L18.59,1.78 L20,3.18 Z M17.79,8.22 C17.92,8.79 18,9.39 18,10 C18,14.42 14.42,18 10,18 C5.58,18 2,14.42 2,10 C2,5.58 5.58,2 10,2 C11.58,2 13.04,2.46 14.28,3.25 L15.72,1.81 C14.1,0.67 12.13,0 10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 C20,8.81 19.78,7.67 19.4,6.61 L17.79,8.22 Z"
                                        id="Shape"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default TaskIcon
